import { FC } from 'react';
import Dropdown from '../../../../components/dropdown';
import useDropdown from '../../../../components/dropdown/hook';
import Unbutton from '../../../../components/form/button/unbutton';
import { IDropdownTrigger, PATIENT_PROGRESS } from '../../../../types';

interface IProgressDropdown {
  progress: PATIENT_PROGRESS;
  onAddTreatment: () => void;
  onDischarge: () => void;
  triggerProps?: Partial<IDropdownTrigger>;
}

const ProgressDropdown: FC<IProgressDropdown> = props => {
  const { progress, onAddTreatment, triggerProps = {}, onDischarge } = props;

  const { id, isOpen, setIsOpen } = useDropdown();

  const handleToggle = () => {
    setIsOpen(current => !current);
  };

  const handleAddTreatment = () => {
    onAddTreatment();
    setIsOpen(false);
  };

  const handleDischarge = () => {
    setIsOpen(false);
    onDischarge();
  };

  return (
    <Dropdown id={id} isOpen={isOpen} setIsOpen={setIsOpen}>
      <Dropdown.Trigger id={id} handleToggle={handleToggle} {...triggerProps}>
        Actions
      </Dropdown.Trigger>
      <Dropdown.Menu id={id}>
        {progress !== PATIENT_PROGRESS.DISCHARGED && (
          <>
            <Dropdown.Item>
              <Unbutton onClick={handleAddTreatment}>Add treatment</Unbutton>
            </Dropdown.Item>
            <Dropdown.Item>
              <Unbutton onClick={handleDischarge}>Discharge</Unbutton>
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProgressDropdown;
